define('shared/util/fields/common',[
    'shared/initializer/form/constants',
    'shared/lib/RSVP',
    'shared/lib/console',
    '$'
], 
function (
    constants,
    RSVP,
    console,
    $
) {
    'use strict';

    function setFieldValue(sourceValue, targetName, $form) {
        var $target = $form.find('input[name="' + targetName + '"]');
        if ($target.length > 0) {
            $target.val(sourceValue);
        } else {
            $('<input>').attr({
                type: 'hidden',
                name: targetName,
                value: sourceValue
            }).appendTo($form);
        }
    }

    function setFieldValueIfExists(sourceValue, targetName, $form) {
        var $target = $form.find('input[name="' + targetName + '"]');
        if ($target.length > 0) {
            $target.val(sourceValue);
        }
    }

    function appendFieldValueIfExists(sourceValue, targetName, $form) {
        var $target = $form.find('input[name="' + targetName + '"]');
        if ($target.length > 0) {
            $target.val($target.val() + sourceValue);
        }
    }

    function copyFieldInternal(source, target, $form) {
        var $source = $form.find('[name="' + source + '"]');
        if($source.length <= 0) {
            return;
        }

        if($source.is(':checkbox') && !$source.is(':checked')){
            return;
        }

        return setFieldValue($source.val(), target, $form);
    }

    function copyField(source, target, $form) {
        if(Array.isArray(source)){
            for(var i = 0; i < source.length; i++){
                copyFieldInternal(source[i], target, $form);
            }
        }
        else{
            copyFieldInternal(source, target, $form);
        }
    }

    return {
        copyField: copyField,
        setFieldValue: setFieldValue,
        setFieldValueIfExists: setFieldValueIfExists,
        appendFieldValueIfExists: appendFieldValueIfExists
    };
});
